// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const asitvColors: ColorType = { ...colorPalette, primary: '#0042FF', secondary: '#0042FF' }

export const lightTheme = {
  colors: asitvColors,
  background: {
    primary: '#fafafa',
    secondary: '#fafafa',
    highlight: asitvColors.light,
    select: '#fafafa',
    footerTop: '#ccc',
  },
  text: {
    primary: asitvColors.dark,
    secondary: asitvColors.grayText,
    disabled: asitvColors.dark,
    link: asitvColors.dark,
    hint: asitvColors.dark,
    highlight: asitvColors.primary,
    gray: asitvColors.grayText,
    seeAll: 'rgba(52, 73, 94, 0.8)',
    primaryContrast: '#ffffff',
  },
  border: {
    primary: '#dddddd',
    gray: '#ddd',
  },
  filter: {
    primary: '#43484d',
    secondary: '#43484d',
    disabled: asitvColors.grayLabel,
    highlight: '#fff',
  },
  tabs: {
    bg: '#fafafa',
    containerBg: asitvColors.dark,
    color: asitvColors.dark,
    border: asitvColors.primary,
    scrollbarThumb: asitvColors.primary,
    programTitle: asitvColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: 'rgba(221, 221, 221, 0.8)',
        hover: asitvColors.dark,
        selected: asitvColors.dark,
        progress: rgba(asitvColors.primary, 0.3),
        past: rgba(asitvColors.primary, 0.3),
        pastSelected: asitvColors.dark,
        pastHover: asitvColors.dark,
        empty: 'rgba(221, 221, 221, 0.3)',
        emptyProgress: rgba(asitvColors.primary, 0.1),
      },
      text: {
        empty: asitvColors.grayLabel,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #fafafa 0%,${rgba('#fafafa', 0.97)} 13.03%,${rgba('#fafafa', 0.69)} 43.24%,${rgba(
          '#fafafa',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0,#fafafa 0%,${rgba('#fafafa', 0.73)} 34.97%,${rgba('#fafafa', 0)} 100%);`,
    },
  },
  card: {
    title: asitvColors.dark,
    subTitle: asitvColors.grayText,
    bg: asitvColors.dark,
    number: asitvColors.grayBorder,
    boxShadow: 'rgba(221, 221, 221, 0.8)',
    loaderBackgroundImage: 'linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%)',
  },
  dimension: {
    signLogoSize: 148,
  },
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
